// Planta Application has two ways of running and separate configuration for each of them.
// 1. Standalone - run in a Docker container, reading configuration from environment variables that can
//                 be changed without a need of rebuilding the application: `window.__RUNTIME_CONFIG__`
// 2. Opp Parcel - run as an component within OPP application, reading hardcoded configuration from `OPP_PARCEL_CONFIG`
// TODO: when PLANTA as Standalone application will be deprecated adjust config to Parcel only

import { getEnvironment } from "@pdpp/lib-react";

declare global {
  interface Window {
    readonly __RUNTIME_CONFIG__: ImportMetaEnv;
  }
}

const sharedConfig = {
  SENTRY_RELEASE: "",
  SENTRY_DSN:
    "https://c879b80b1fe34674b91166b2271e7ad1@o478484.ingest.sentry.io/4505036841287680",
  VITE_TRACKER_URL: "",
  BASE_URL: "",
  MODE: "",
  DEV: false,
  PROD: false,
  SSR: false,
  VITE_APP_CLIENT_ID: "ca1e6eb0-29a0-4f90-9c4b-e7cc6e4e4750",
  OPP_AUTHZ: "true",
  FILE_INSTRUCTION_URL:
    "https://iweof.sharepoint.com/:b:/r/sites/ms/rwm/hr/globalpeopleplanninghub/Shared%20Documents/Workload%20planning/1.%20User%20manual/Upload%20File%20Instruction/Workload_Planning_Upload-File_Instruction_2026.pdf?csf=1&web=1&e=rYKpJr",
  ADMIN_GROUP_IDS:
    "2e894baa-ba93-438c-8dd3-76041dbdaaf9,2f9847ea-654e-4d38-b29d-8951ba615e45",
  FORECASTING_DASHBOARD_URL: "",
  VITE_FORECASTING_DASHBOARD_URL:
    "https://app.powerbi.com/groups/1cba664d-e5a2-4a48-ade4-a9f60605280b/reports/0cd3e21a-bf41-4438-8ee0-f1871bf7eedd?ctid=720b637a-655a-40cf-816a-f22f40755c2c&pbi_source=linkShare",
  EXAMPLE_EXCEL_URL: "/assets/hc-upload-template.xlsx",
};

const OPP_PARCEL_CONFIG: OppParcelConfig = {
  dev: {
    VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
    VITE_API_URL: "https://planta-dev.ingkadt.com/api",
    VITE_API_URL_FORECAST: "https://forecasting-dev.ingkadt.com/api",
    ENVIRONMENT: "dev-v1",
    ...sharedConfig,
  },
  stage: {
    VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
    VITE_API_URL: "https://planta-stage.ingkadt.com/api",
    VITE_API_URL_FORECAST: "https://forecasting-stage.ingkadt.com/api",
    ENVIRONMENT: "stage-v1",
    ...sharedConfig,
  },
  prod: {
    VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
    VITE_API_URL: "https://planta.ingka.com/api",
    VITE_API_URL_FORECAST: "https://forecasting.ingka.com/api",
    ENVIRONMENT: "prod-v1",
    ...sharedConfig,
  },
};

const prodOPP = "peopleplanning.ingka.com";
const OPP_ENV = getEnvironment(prodOPP);

console.info(`Running Workload Parcel in ${OPP_ENV} environment`);

function get(key: string): string {
  const c = window.__RUNTIME_CONFIG__ ?? OPP_PARCEL_CONFIG[OPP_ENV];
  return c[key];
}

function getWithFallback(key: string): string {
  const windowConfig = window.__RUNTIME_CONFIG__;
  const oppConfig = OPP_PARCEL_CONFIG[OPP_ENV];

  return windowConfig !== undefined && windowConfig[key] !== undefined
    ? windowConfig[key]
    : oppConfig[key];
}

export const ENVIRONMENT = get("ENVIRONMENT");
export const SENTRY_RELEASE = get("SENTRY_RELEASE");
export const SENTRY_DSN = get("SENTRY_DSN");
export const VITE_APP_CLIENT_ID = get("VITE_APP_CLIENT_ID");
export const VITE_APP_TENANT_ID = get("VITE_APP_TENANT_ID");
export const VITE_API_URL = get("VITE_API_URL");
export const VITE_TRACKER_URL = get("VITE_TRACKER_URL");
export const FILE_INSTRUCTION_URL = getWithFallback("FILE_INSTRUCTION_URL");
export const ADMIN_GROUP_IDS = get("ADMIN_GROUP_IDS");
export const FORECASTING_DASHBOARD_URL = get("FORECASTING_DASHBOARD_URL");
export const EXAMPLE_EXCEL_URL = get("EXAMPLE_EXCEL_URL");
export const OPP_AUTHZ = get("OPP_AUTHZ") === "true";
export const VITE_API_URL_FORECAST = get("VITE_API_URL_FORECAST");
